module.exports = __webpack_public_path__ + "3c40a73de3ddfd6e9f4cdca6e2d2bb9a.pdf";